module.exports = __webpack_public_path__ + "static/media/moove-banner.0a4ba157.png";